import { render, staticRenderFns } from "./UserQuestion.vue?vue&type=template&id=a811449a&scoped=true&"
import script from "./UserQuestion.vue?vue&type=script&lang=js&"
export * from "./UserQuestion.vue?vue&type=script&lang=js&"
import style0 from "./UserQuestion.vue?vue&type=style&index=0&id=a811449a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a811449a",
  null
  
)

export default component.exports